import {createAction} from 'util/redux'
import {CFGroupTO} from 'generated/JavaTO'

const NAMESPACE = 'CFGROUP/'
export const resetCFDefGroupsAction = createAction<CFGroupTO[]>(NAMESPACE + 'reset')